"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _index = _interopRequireDefault(require("../Button/index"));
var _ArrowRight = _interopRequireDefault(require("../Icon/Icons/ArrowRight"));
var _ArrowLeft = _interopRequireDefault(require("../Icon/Icons/ArrowLeft"));
var _CarouselItems = _interopRequireDefault(require("./CarouselItems"));
var _colors = require("../style/colors");
var _animations = require("../style/animations");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const CarouselStyled = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "Carousel__CarouselStyled",
  componentId: "bufferapp-ui__sc-1ycsokk-0"
})(["align-items:center;display:flex;"]);
const Window = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "Carousel__Window",
  componentId: "bufferapp-ui__sc-1ycsokk-1"
})(["overflow:hidden;width:", ";margin:8px;display:flex;"], props => props.width);
const ButtonOverlapContainer = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "Carousel__ButtonOverlapContainer",
  componentId: "bufferapp-ui__sc-1ycsokk-2"
})(["position:relative;z-index:3;", ""], props => props.left ? (0, _styledComponents.css)(["left:20px;"]) : (0, _styledComponents.css)(["right:20px;"]));
const MainList = /*#__PURE__*/_styledComponents.default.ul.withConfig({
  displayName: "Carousel__MainList",
  componentId: "bufferapp-ui__sc-1ycsokk-3"
})(["display:flex;padding:0;margin:0;position:relative;left:", ";transition:left 0.4s ", ";"], props => `${props.left}px`, _animations.easeOutQuart);
const Announcement = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "Carousel__Announcement",
  componentId: "bufferapp-ui__sc-1ycsokk-4"
})(["position:absolute !important;height:1px;width:1px;overflow:hidden;clip-path:inset(1px 1px 1px 1px);white-space:nowrap;margin:0;"]);
const IndicatorList = /*#__PURE__*/_styledComponents.default.ol.withConfig({
  displayName: "Carousel__IndicatorList",
  componentId: "bufferapp-ui__sc-1ycsokk-5"
})(["padding:0;margin:0;display:flex;justify-content:center;"]);
const IndicatorListItem = /*#__PURE__*/_styledComponents.default.li.withConfig({
  displayName: "Carousel__IndicatorListItem",
  componentId: "bufferapp-ui__sc-1ycsokk-6"
})(["list-style:none;padding:0 4px;position:relative;display:flex;"]);
const IndicatorButton = /*#__PURE__*/_styledComponents.default.button.withConfig({
  displayName: "Carousel__IndicatorButton",
  componentId: "bufferapp-ui__sc-1ycsokk-7"
})(["width:11px;height:11px;padding:0;border:none;border-radius:50%;background-color:", ";:hover{cursor:pointer;}&:after{content:'';display:block;width:11px;height:11px;border-radius:50%;background:", ";position:absolute;top:0;left:4px;transform:", ";transition:transform ", " ease-out;}&:before{content:'';display:block;width:13px;height:13px;border-radius:50%;border:1px solid ", ";position:absolute;top:0;left:2px;opacity:0;transition:opacity 100ms ease-out;transition-delay:", ";}&:hover{&:after{transform:scale(1);}&:before{opacity:1;}}"], _colors.gray, _colors.white, _ref => {
  let {
    active
  } = _ref;
  return active ? 'scale(1)' : 'scale(0)';
}, _ref2 => {
  let {
    active
  } = _ref2;
  return active ? '250ms' : '150ms';
}, _colors.white, _ref3 => {
  let {
    active
  } = _ref3;
  return active ? '0' : '150ms';
});
const Content = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "Carousel__Content",
  componentId: "bufferapp-ui__sc-1ycsokk-8"
})(["display:flex;flex-direction:column;"]);
class Carousel extends _react.default.Component {
  constructor() {
    super(...arguments);
    this.state = {
      left: 0,
      currentSlideIndex: 0
    };
    this.verifyLastItem = (lengthOfChildren, widthOfEachItem) => {
      const {
        left
      } = this.state;
      const finalLength = (lengthOfChildren - 1) * parseInt(widthOfEachItem, 10);
      return left === -finalLength;
    };
    this.goToSlide = index => {
      const {
        width,
        children
      } = this.props;
      const {
        currentSlideIndex,
        left
      } = this.state;
      if (currentSlideIndex > index) {
        if (left === 0) {
          const finalLength = (_react.default.Children.count(children) - 1) * parseInt(width, 10);
          this.setState({
            left: -finalLength,
            currentSlideIndex: _react.default.Children.count(children) - 1
          });
          return;
        }
      }
      if (currentSlideIndex < index) {
        if (this.verifyLastItem(_react.default.Children.count(children), width)) {
          this.setState({
            left: 0,
            currentSlideIndex: 0
          });
          return;
        }
      }
      const newLeft = parseInt(width, 10) * index;
      this.setState({
        left: -newLeft,
        currentSlideIndex: index
      });
    };
  }
  render() {
    const {
      left,
      currentSlideIndex
    } = this.state;
    const {
      children,
      width,
      rightNavigation,
      withIndicators
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(CarouselStyled, null, /*#__PURE__*/_react.default.createElement(Announcement, {
      "aria-live": "polite",
      "aria-atomic": "true",
      tabIndex: -1
    }, "Slide", currentSlideIndex + 1, "out of", children.length), _react.default.Children.count(children) > 1 && !rightNavigation && ( /*#__PURE__*/_react.default.createElement(ButtonOverlapContainer, {
      left: true
    }, /*#__PURE__*/_react.default.createElement(_index.default, {
      type: "secondary",
      icon: /*#__PURE__*/_react.default.createElement(_ArrowLeft.default, null),
      hasIconOnly: true,
      onClick: () => {
        this.goToSlide(currentSlideIndex - 1);
      },
      label: "Backwards"
    }))), /*#__PURE__*/_react.default.createElement(Content, null, /*#__PURE__*/_react.default.createElement(Window, {
      width: width
    }, /*#__PURE__*/_react.default.createElement(MainList, {
      left: left
    }, /*#__PURE__*/_react.default.createElement(_CarouselItems.default, {
      currentSlideIndex: currentSlideIndex
    }, children))), _react.default.Children.count(children) > 1 && withIndicators && ( /*#__PURE__*/_react.default.createElement(IndicatorList, null, _react.default.Children.map(children, (child, index) => ( /*#__PURE__*/_react.default.createElement(IndicatorListItem, {
      key: index
    }, /*#__PURE__*/_react.default.createElement(IndicatorButton, {
      type: "button",
      onClick: () => this.goToSlide(index),
      active: index === currentSlideIndex
    }, /*#__PURE__*/_react.default.createElement(Announcement, {
      as: "p"
    }, index === currentSlideIndex ? `Currently on slide
                    ${index + 1}` : `Go to slide ${index + 1}`)))))))), _react.default.Children.count(children) > 1 && ( /*#__PURE__*/_react.default.createElement(ButtonOverlapContainer, null, /*#__PURE__*/_react.default.createElement(_index.default, {
      type: "secondary",
      icon: /*#__PURE__*/_react.default.createElement(_ArrowRight.default, null),
      hasIconOnly: true,
      onClick: () => {
        this.goToSlide(currentSlideIndex + 1);
      },
      label: "Forwards"
    }))));
  }
}
Carousel.defaultProps = {
  rightNavigation: false,
  withIndicators: true
};
Carousel.propTypes = {
  children: _propTypes.default.node.isRequired,
  width: _propTypes.default.string.isRequired,
  rightNavigation: _propTypes.default.bool,
  withIndicators: _propTypes.default.bool
};
var _default = exports.default = Carousel;